import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { playPath } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'

const resource = createResource({
  en: {
    title: 'Get To Know About ',
    pintar: 'Pintar Score!',
    download: 'Scan to download, know your Pintar Score!',
    desc: 'Keep paying in time, you will get a higher Pintar Score, thus get a higher loan limit! You also can get more than 1 concurrent loan, get gifts and discount! Check below:',
  },
  id: {
    title: 'Mengenal ',
    pintar: 'Skor Pintar!',
    desc: 'Terus bayar tepat waktu, Anda akan mendapatkan Skor Pintar dan limit pinjaman yang lebih tinggi! Anda juga bisa mendapatkan lebih dari 1 pinjaman bersamaan, dapatkan hadiah dan diskon! Cek di bawah ini:',
    download: 'Scan untuk Download dan Ketahui Skor Pintar Milikmu!',
  },
})

const GuideBanner = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const url = width > 1000 ? null : playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.HOME)

  const eventClick = () => {
    eventLogProducer.push({
      action: Action.GETITONGOOGLEPLAYBUTTONCLICK,
    })
  }

  return (
    <BannerBox>
      <div className="container">
        <div className="main-guide">
          <h1 className="title">
            {t('title')} <span className="color">{t('pintar')}</span>
          </h1>
          <p className="desc">{t('desc')}</p>
        </div>
        <a href={url} rel="noopener noreferrer nofollow" target="_blank" onClick={eventClick} className="download">
          <div className="down-hook">
            <img className="download-icon" src={`/images/guide/guide-google-logo.png`} alt="guide-google-logo" />
            <p className="download-content">{t('download')}</p>
            <img className="qrcode qrcode_mini" src="/images/qrcode/qr_score_mini.png" alt="qrcode_mini" />
            <img className="qrcode qr_score_gp" src="/images/qrcode/qr_home_gp.png" alt="qrcode" />
          </div>
        </a>
      </div>
    </BannerBox>
  )
}

export default GuideBanner

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    padding-top: 62px;
    .container {
      position: relative;
      width: 100%;
      margin: 0 auto 45px;
      padding: 0 24px;
      .main-guide {
        padding: 32px 0 18px;
        .title {
          font-size: 26px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          .color {
            color: #1cc812;
          }
        }
        .desc {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
        }
      }
      .download {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 80px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #1cc812;
        .down-hook {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .download-icon {
            width: 48px;
            margin-right: 16px;
          }
          .download-content {
            font-size: 16px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #1cc812;
            max-width: 200px;
          }
          .qrcode {
            display: none;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    .container {
      height: 440px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      padding: 0 150px;
      .main-guide {
        padding: 72px 0 36px;
        .title {
          font-size: 44px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          white-space: nowrap;
          text-align: center;
          .color {
            color: #1cc812;
          }
        }
        .desc {
          font-size: 32px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 36px;
        }
      }
      .download {
        display: flex;
        justify-content: center;
        width: 1140px;
        height: 112px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #1cc812;
        .down-hook {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .download-icon {
            width: 64px;
          }
          .download-content {
            font-size: 30px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #1cc812;
            margin: 0 32px;
          }
          .qrcode {
            width: 64px;
            height: 64px;
            z-index: 1;
            opacity: 0;
          }
          .qr_score_gp {
            width: 64px;
            height: 64px;
            z-index: 1;
            opacity: 0;
            display: none;
          }
          .qrcode_mini {
            opacity: 1;
          }
        }
        .down-hook:hover .qrcode_mini {
          width: 64px;
          height: 64px;
        }
        .down-hook:hover .qr_score_gp {
          position: absolute;
          top: 100px;
          right: 0;
          display: block;
          width: 200px;
          height: 200px;
          border-radius: 6px;
          background: #fff;
          box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid #f5f5f5;
          opacity: 1;
          z-index: 1;
        }
      }
    }
  }
`
